<template>
    <d2-container :filename="filename">
        <!--<template slot="header">修改数据</template>-->
        <d2-crud
                :columns="columns"
                :data="data"
                title="黑名单"
                :pagination="pagination"
                add-mode
                :rowHandle="rowHandle"
                :form-template="formTemplate"
                :form-options="formOptions"
                @row-add="handleRowAdd"
                @row-remove="handleRowRemove"
                @dialog-cancel="handleDialogCancel">
            <el-button slot="headerButton" @click="getData">
                <d2-icon name="refresh"></d2-icon>
            </el-button>
        </d2-crud>

        <template slot="footer">
            www.heanny.cn
        </template>
    </d2-container>
</template>

<script>
    export default {
        data() {
            return {
                filename: __filename,

                columns: [
                       {
                        title: 'IP/邮箱',
                        key: 'data'
                    }
                ],
                data: [],
                pagination: {
                    pageSize: 10,
                    layout: 'prev, pager, next, total'
                },
                rowHandle: {
                    columnHeader: '操作',
                    remove: {
                        icon: 'el-icon-delete',
                        size: 'small',
                        fixed: 'right',
                        confirm: true,
                    }
                },
                formTemplate: {
                    data: {
                        title: 'IP/邮箱',
                        value: '',
                    },
                },
                formOptions: {
                    labelWidth: '80px',
                    labelPosition: 'left',
                    saveLoading: false
                }
            }
        },
        methods: {
            handleRowAdd(row, done) {
                this.formOptions.saveLoading = true
                if (row.tag === '') {
                    this.$message.error('IP/邮箱为空')
                    this.formOptions.saveLoading = false
                    return
                }
                this.$request({url: 'createBLip.do', data: row}).then(res => {
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        })
                        done()
                        this.formOptions.saveLoading = false
                    }
                ).catch(e=>{
                    this.formOptions.saveLoading = false
                })

            },
            handleDialogCancel(done) {
                this.$message({
                    message: '取消编辑',
                    type: 'warning'
                })
                done()
            },
            handleRowRemove({index, row}, done) {
                this.$request({url: 'delBLip.do',  data: row}).then(res => {
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    })
                    done()
                })
            }, getData() {
                const _this = this
                this.$request({url: 'getBlackList.do'}).then(res => {
                    _this.data = res
                }).catch((error) => {
                    this.msg = error
                })
            }
        }, created: function () {

            this.getData()
        }
    }
</script>
